/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'

import { initFlowbite } from 'flowbite'

import { Pagination } from 'components'

import { _object } from 'utils/interfaces'

import { DeleteIcon, EditIcon } from 'assets/svg'
import { sliderService } from 'services/slider.service'
import SliderModal from 'components/modal/slider-edit-modal'
import SliderAddModal from 'components/modal/slider-add-modal'
import { Placeholder } from 'assets/images'

const SlideTab = () => {
  const [loading, setLoading] = useState(false)
  const [results, setResults] = useState<_object>({})
  // const [selectedBrandId, setSelectedBrandId] = useState<string | null>(null)

  const [filters, setFilters] = useState<_object>({
    q: '',
    page: 1,
    per_page: 25,
    sort: '-created_at'
  })
  const getSlide = () => {
    sliderService.getSliders(filters).then((results) => {
      setResults(results)
      setLoading(false)
    })
  }
  useEffect(() => {
    getSlide()
    setLoading(true)
  }, [filters])

  const deleteSlide = (id: string) => {
    if (window.confirm('Are you sure you want to delete?')) {
      sliderService.deleteSlide(id).then(() => {
        getSlide()
      })
    }
  }
  useEffect(() => {
    initFlowbite()
  })

  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">
            Slides <small>Total records: {results?.pagination?.total_items}</small>
          </h1>
        </div>
        <button
          className="rounded-md border border-purple-900 bg-purple-900 hover:bg-purple-950 px-4 py-2 text-sm text-white font-medium"
          data-modal-target={'slider-add-modal'}
          data-modal-toggle={'slider-add-modal'}
          type="button"
        >
          Add New Slide
        </button>
      </div>
      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold">#</th>
              <th className="px-4 py-3 font-semibold">Title</th>
              <th className="px-4 py-3 font-semibold">Status</th>
              <th className="py-3 text-sm">
                <p className="ms-8 font-semibold text-gray-900 text-sm">Image
                </p>
                <span className='text-[10px] text-[#969494] font-medium'>1904W × 1072H | 16:9</span>
              </th>
              <th className="px-4 py-3 text-end font-semibold">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {loading === false ? (
              results?.items?.map((item: _object, i: number) => {
                return (
                  <>
                    <tr className="hover:bg-gray-50" key={i}>
                      <td className="px-4 py-3">{i + 1}</td>
                      <td className="px-4 py-3">{item?.title}</td>
                      <td className="px-4 py-3">{item?.status}</td>
                      <td className="px-4 py-3">
                        <div className="h-[50px] w-[50px]">
                          <img
                            src={item?.image || Placeholder}
                            alt={item.title}
                            className="rounded-md w-full h-full object-cover"
                          />
                        </div>
                      </td>

                      <td className="text-end gap-2 px-4 py-3">
                        <button
                          type="button" className='me-2'
                          onClick={() => deleteSlide(item.id)}
                          title="Delete Slide"
                        >
                          <DeleteIcon className="h-[20px] w-[20px]" />
                        </button>

                        <button
                          data-modal-target={`slider-modal${item?.id}`}
                          data-modal-toggle={`slider-modal${item?.id}`}
                          type="button"
                          title="Edit Slide"
                        // onClick={() => {
                        //   setSelectedBrandId(item.id)
                        // }}
                        >
                          <EditIcon className="h-[20px] w-[20px]" />
                        </button>
                      </td>
                    </tr>
                    <SliderModal id={item.id} />
                  </>
                )
              })
            ) : (
              <SliderSkeleton />
            )}
            {results?.items?.length <= 0 &&
              <td colSpan={12} className="text-center py-6 text-gray-500">
                <p>No record found</p>
              </td>}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {results?.pagination?.total_pages > 1 && (
        <Pagination
          pageCount={results?.pagination?.total_pages}
          current_page={results?.pagination?.current_page}
          onPageChange={(e: _object) => {
            setFilters({ ...filters, page: e.selected + 1 })
          }}
        />
      )}

      <SliderAddModal />
    </>
  )
}
export default SlideTab

const SliderSkeleton = () => {
  return (
    <>
      <tr className="animate-pulse">
        <td className="px-4 py-3">
          <div className="h-4 w-6 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-32 rounded bg-gray-300"></div>
        </td>
        {/* <td className="px-4 py-3">
          <div className="h-4 w-12 rounded bg-gray-300"></div>
        </td> */}
        <td className="px-4 py-3">
          <div className="h-4 w-8 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-8 rounded bg-gray-300"></div>
        </td>
        <td className="flex justify-end gap-2 px-4 py-3">
          <div className="h-5 w-5 rounded-full bg-gray-300"></div>
          <div className="h-5 w-5 rounded-full bg-gray-300"></div>
        </td>
      </tr>
    </>
  )
}
